import VanillaCalendar from './components/calendar';

const calendarWrappers = document.querySelectorAll('.js-event-calendar-wrapper');

calendarWrappers.forEach(wrapper => {
    // Posts
    const eventPosts = wrapper.querySelectorAll('.js-event-calendar-posts');
    const noEventPosts = wrapper.querySelector('.js-event-calendar-posts-none');
    const monthSpans = wrapper.querySelectorAll('.js-event-calendar-month');
    const months = [];
    monthSpans.forEach(span => {
        let month = span.innerHTML;
        months.push(month);
    })
    // Calendar
    const calendar = wrapper.querySelector('.js-event-calendar');
    const dateMin = calendar.getAttribute('data-datemin');
    const dateSpans = wrapper.querySelectorAll('.js-event-calendar-date');
    const dates = [];
    dateSpans.forEach(span => {
        const date = span.innerHTML;
        dates.push(date);
    })
    const selectedDates = [];
    const firstDate = dates[0];
    selectedDates.push(firstDate);

    const initCalendar = new VanillaCalendar(calendar, {
        date: {
            min: dateMin,
        },
        settings: {
            range: {
                disablePast: true,
                disableAllDays: true,
                enabled: dates
            },
            selection: {
                month: 'only-arrows',
                year: false,
                day: false
            },
            visibility: {
                today: true,
                daysOutside: false,
            },
        },
        actions: {
            clickArrow(e, self) {
                let selectedMonth = self.selectedMonth;
                selectedMonth++;
                let thisMonth = selectedMonth.toLocaleString('en-US', {
                    minimumIntegerDigits: 2,
                    useGrouping: false
                });
                let thisYear = self.selectedYear;
                let thisMonthYear = thisYear + '-' + thisMonth;
                
                eventPosts.forEach(post => {
                    const postMonth = post.dataset.month;
                    const postYear = post.dataset.year;

                    post.classList.remove('show');
                    if( postMonth == thisMonth && postYear == thisYear ) {
                        post.classList.add('show');
                    }
                })

                if( months.includes(thisMonthYear) ) {
                    noEventPosts.classList.remove('show');
                } else {
                    noEventPosts.classList.add('show');
                }

            },
        },
    });

    initCalendar.init();
});